// test1012
(1012 && 0);
